<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="ac !== null">

      <div class="p-grid">
          <div class="p-col-6">
              <h2>{{ t('common.labels.files') }}</h2>
          </div>
          <div class="p-col-6 p-text-right" *ngIf="(ac.not_yet_started || ac.is_template) && inEdit !== true">
            <button [withRight]="'admin.' + mode + '.edit'" pButton (click)="onNew()" type="button" label="{{ t('common.labels.new') }}" icon="pi pi-plus" class="p-button-sm p-button-success p-mb-2 autofocus"></button>
          </div>
      </div>

      <p-table *ngIf="inEdit === true || files?.length > 0" [value]="files">
          <ng-template pTemplate="header">
              <tr>
                  <th style="width: 70%">{{ t('common.labels.file') }}</th>
                  <th>{{ t('common.labels.rights') }}</th>
                  <th style="width: 150px;"></th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-resource>
              <tr *ngIf="inEdit !== true || editResource !== resource">
                <td><p>{{ resource.public_name }}</p></td>
                <td>
                  <fa-icon *ngIf="resource.permissions?.indexOf('candidate') !== -1" [icon]="faStreetView" class="p-ml-2" pTooltip="{{ t('common.labels.candidate') }}"></fa-icon>
                  <fa-icon *ngIf="resource.permissions?.indexOf('observer') !== -1" [icon]="faUsers" class="p-ml-2" pTooltip="{{ t('common.labels.observer') }}"></fa-icon>
                </td>
                <td style="vertical-align: top; text-align: right">
                  <span *ngIf="inEdit !== true">
                    <button pButton (click)="onDownload(resource)" type="button" icon="pi pi-download" class="p-ml-2"></button>
                    <button [withRight]="'admin.' + mode + '.edit'" *ngIf="ac.not_yet_started || ac.is_template" pButton (click)="onEdit(resource)" type="button" icon="pi pi-pencil" class="p-button-outlined p-ml-2"></button>
                    <button [withRight]="'admin.' + mode + '.edit'" *ngIf="ac.not_yet_started || ac.is_template" pButton (click)="onStartDelete(resource)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2"></button>
                  </span>
                </td>
              </tr>
              <tr *ngIf="inEdit === true && editResource === resource">
                <ng-template [ngTemplateOutlet]="tForm"></ng-template>
              </tr>
          </ng-template>
      </p-table>

      <p *ngIf="inEdit !== true && files?.length === 0">{{ t('common.texts.no_files') }}</p>

  </form>

  <ng-template #tForm>
    <td style="vertical-align: top;">
      <app-form-control [cid]="'filename'" [control]="form.get('filename')" [type]="'input'" [label]="''" [basevalue]="editResource?.public_name"></app-form-control>
    </td>
    <td>
      <div class="p-grid">
        <div class="p-col-6">
          <div class="p-field-checkbox p-mb-0">
            <p-checkbox [formControl]="form.get('candidate')" binary="true"></p-checkbox>
            <label for="description"><fa-icon [icon]="faStreetView" class="p-mr-2" pTooltip="{{ t('common.labels.candidate') }}"></fa-icon></label>
          </div>
        </div>
        <div class="p-col-6">
          <div class="p-field-checkbox p-mb-0">
            <p-checkbox [formControl]="form.get('observer')" binary="true"></p-checkbox>
            <label for="description"><fa-icon [icon]="faUsers" class="p-ml-2" pTooltip="{{ t('common.labels.observer') }}"></fa-icon></label>
          </div>
        </div>
      </div>
    </td>
    <td style="vertical-align: top; text-align: right">
      <app-form-buttons [submitting]="submitting" [icons]="false" (cancelled)="onCancel()"></app-form-buttons>
    </td>
  </ng-template>

  <app-file-handling #filehandler [owner]="ac" [ownerType]="ownerType" [mode]="mode" (filesUpload)="onFilesUpload($event)" (fileDelete)="onDelete($event)"></app-file-handling>

  <app-inherit-dialog
    [title]="t('common.labels.save')"
    [mode]="'template'"
    [(visible)]="inheritVisible"
    (okClicked)="saveChanges($event)"
  ></app-inherit-dialog>

</ng-container>
